import React from "react";
import { Box, LinearProgress } from "@mui/material";

const styles = {
  root: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    zIndex: 2000,
  },
  progressContainer: {
    width: 400,
  },
};

export default function SplashScreen() {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.progressContainer}>
        <LinearProgress />
      </Box>
    </Box>
  );
}
